import type {
  TestingInstructionNote,
  TestingInstructionNoteInput,
} from './types';

export type TestingInstructionNoteLike = {
  id: string;
  title: string;
  content: string;
  category: TestingInstructionNote['category'];
  applyMode?: TestingInstructionNote['applyMode'] | null;
  pipelines?: TestingInstructionNote['pipelines'] | null;
  endpointGlobs?: string[] | null;
  description?: string | null;
};

export const toTestingInstructionNote = (
  note: TestingInstructionNoteLike,
): TestingInstructionNote => ({
  id: note.id,
  title: note.title,
  content: note.content,
  category: note.category,
  applyMode: note.applyMode ?? 'ALWAYS',
  pipelines: note.pipelines ?? [],
  endpointGlobs: note.endpointGlobs ?? [],
  description: note.description ?? null,
});

export const toTestingInstructionNoteBody = (
  note: TestingInstructionNoteInput,
): Omit<TestingInstructionNote, 'id'> => ({
  title: note.title,
  content: note.content,
  category: note.category,
  applyMode: note.applyMode,
  pipelines: note.pipelines,
  endpointGlobs: note.endpointGlobs,
  description: note.description,
});
